var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm._m(0),
    _c("div", { staticClass: "card card-body" }, [
      _vm.archivedProjects.length > 0 || _vm.activeProjects.length > 0
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("div", [
              _c("table", { staticClass: "table align-items-center" }, [
                _vm._m(1),
                _c(
                  "tbody",
                  { staticClass: "list" },
                  [
                    _vm._l(_vm.activeProjects, function (p, i) {
                      return _c("tr", { key: i }, [
                        _c("th", { attrs: { scope: "row" } }, [
                          _c(
                            "div",
                            { staticClass: "media align-items-center" },
                            [
                              _c("div", { staticClass: "media-body" }, [
                                _c(
                                  "span",
                                  { staticClass: "name mb-0 text-sm" },
                                  [_vm._v(_vm._s(p.name))]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("td", { staticClass: "budget" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(p.billing_date) +
                              "\n                "
                          ),
                        ]),
                        _c("td", { staticClass: "budget" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(p.currency) +
                              " " +
                              _vm._s(p.amount_paid) +
                              " - per month\n                "
                          ),
                        ]),
                        _c("td", [
                          _c("span", { staticClass: "badge badge-dot mr-4" }, [
                            _c("span", { staticClass: "status" }, [
                              _vm._v(
                                _vm._s(p.approval_status.replace("_", " "))
                              ),
                            ]),
                          ]),
                        ]),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm text-white bg-danger my-2 mt-2 mb-2 ml-2 my-md-0",
                              attrs: {
                                type: "button",
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onArchieveClicked(p)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    Archive\n                  "
                              ),
                            ]
                          ),
                        ]),
                      ])
                    }),
                    _vm._l(_vm.archivedProjects, function (p, i) {
                      return _c("tr", { key: i }, [
                        _c("th", { attrs: { scope: "row" } }, [
                          _c(
                            "div",
                            { staticClass: "media align-items-center" },
                            [
                              _c("div", { staticClass: "media-body" }, [
                                _c(
                                  "span",
                                  { staticClass: "name mb-0 text-sm" },
                                  [_vm._v(_vm._s(p.name))]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("td", { staticClass: "budget" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(p.billing_date) +
                              "\n                "
                          ),
                        ]),
                        _c("td", { staticClass: "budget" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(p.currency) +
                              " " +
                              _vm._s(p.amount_paid) +
                              " - per month\n                "
                          ),
                        ]),
                        _c("td", [
                          _c("span", { staticClass: "badge badge-dot mr-4" }, [
                            _c("span", { staticClass: "status" }, [
                              _vm._v(
                                _vm._s(p.approval_status.replace("_", " "))
                              ),
                            ]),
                          ]),
                        ]),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm text-white bg-success my-2 mt-2 mb-2 ml-2 my-md-0",
                              attrs: {
                                type: "button",
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onUnArchieveClicked(p)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    Make Active\n                  "
                              ),
                            ]
                          ),
                        ]),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _c("div", [_vm._m(2)]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "navbar-dark project-header py-2 px-1 d-flex justify-content-between",
      },
      [_c("div", { staticClass: "d-flex align-items-center" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Project")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Date")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Amount")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Status")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Action")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "text-align": "center" } }, [
      _c("span", [_vm._v("No archieved or active projects found.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }